import apiFetch from '../apiFetch'

export default function (idRaza, token) {
  return apiFetch({endPoint: `Raza/getRazaParaDuplicar?idRaza=${idRaza}`, method: 'GET', body: null, token: token})
}
